/* global L:false */
import angular from 'angular';

module.exports = angular.module('market.directives.neighborhood-map', [])
.directive('obNeighborhoodMap', function() {
  return {
    restrict: 'C',
    scope: {
      pinTitle: '@',
      pinLat: '@',
      pinLon: '@'
    },
    link: function(scope, elem) {
      // Public token; meant to be exposed. URL restrictions are in the Mapbox admin panel.
      L.mapbox.accessToken = 'pk.eyJ1Ijoib3BlbmRvb3IiLCJhIjoiY21tNDNwdmE4MDZsaDJvcG4zYXE4c254NyJ9.5PjzJ7pYIrbodyh1USA5ag'; // eslint-disable-line max-len
      L.mapbox.config.FORCE_HTTPS = true;
      var map = L.mapbox.map(elem[0], 'opendoor.lo70f83n', {
        attributionControl: { compact: true },
        doubleClickZoom: false,
        dragging: false,
        scrollWheelZoom: false,
        tap: false,
        touchZoom: false,
        zoomControl: false
      });

      if (scope.pinLat && scope.pinLon) {
        L.marker([scope.pinLat, scope.pinLon], { title: scope.pinTitle, alt: scope.pinTitle }).addTo(map); // eslint-disable-line max-len
        map.setView([scope.pinLat, scope.pinLon], 16);
      }
    }
  };
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/market/deprecated/neighborhood-map.js
 **/